import { getFeatureFlagValue } from '@citrite/feature-flags';
import { Code } from '@sharefiledev/icons';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import {
	AsyncAccountMFASettings,
	AsyncMFAEnabledUserPreferences,
	AsyncOTPAdminSettings,
	AsyncPasswordRequirements,
	AsyncSingleSignOn,
	AsyncSocialSignIn,
	AsyncSupportSecurityQuestion,
	AsyncUserProfile,
	AsyncUserProfileActions,
} from './ExtensionSlots';
import { FeatureFlag } from './FeatureFlags/FeatureFlagDefinitions';
import { setLogger } from './logger';

export function setup(piletApi: PiletApi) {
	setLogger(piletApi.sf.getLogger());

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:user-preferences',
		({ params }) => <AsyncMFAEnabledUserPreferences piletApi={piletApi} {...params} />
	);

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:user-profile',
		({ params }) => (
			<AsyncUserProfile userRid={params.userRid} piletApi={piletApi} {...params} />
		)
	);

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:mfa-refactored-user-preferences',
		({ params }) => <AsyncMFAEnabledUserPreferences piletApi={piletApi} {...params} />
	);

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:password-requirements',
		({ params }) => <AsyncPasswordRequirements piletApi={piletApi} {...params} />
	);

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:social-sign-in',
		({ params }) => <AsyncSocialSignIn piletApi={piletApi} {...params} />
	);

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:account-mfa-settings',
		({ params }) => <AsyncAccountMFASettings piletApi={piletApi} {...params} />
	);

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:single-sign-on',
		({ params }) => <AsyncSingleSignOn piletApi={piletApi} {...params} />
	);

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:user-profile-actions',
		({ params }) => (
			<AsyncUserProfileActions
				userRID={params.userRID}
				firstName={params.firstName}
				lastName={params.lastName}
				managedUserRoles={params.managedUserRoles}
				isUserActionsPilet={params.isUserActionsPilet}
				piletApi={piletApi}
				{...params}
			/>
		)
	);

	piletApi.registerExtension(
		'urn:sfextslot:sharefile-appshell:identity-pilet:support-security-question',
		({ params }) => <AsyncSupportSecurityQuestion piletApi={piletApi} {...params} />
	);

	if (getFeatureFlagValue(FeatureFlag.EnableOTP)) {
		piletApi.registerExtension(
			'urn:sfextslot:sharefile-appshell:identity-pilet:otp-admin-settings',
			({ params }) => <AsyncOTPAdminSettings piletApi={piletApi} {...params} />
		);
	}

	registerDevPage(piletApi);
}

function registerDevPage(piletApi: PiletApi) {
	if (process.env.NODE_ENV === 'development') {
		piletApi.sf.registerLeftNavComponent({
			href: '/identity-dev',
			title: () => 'Identity Dev',
			icon: () => <Code style={{ fontSize: '24px' }} />,
			weight: 50,
		});
		if (typeof piletApi.meta.config.apiOrigin === 'string') {
			const { configureHttp } = require('./IdentityHttp');
			const { Configuration } = require('./generated/runtime');
			configureHttp((configuration: any) => {
				configuration.config = new Configuration({
					basePath: `${piletApi.meta.config.apiOrigin}/io/identity/v1`,
				});
			});
		}
	}

	piletApi.registerPage('/identity-dev', () => (
		<>
			<AsyncOTPAdminSettings piletApi={piletApi} />
			<br />
			<br />
			<AsyncMFAEnabledUserPreferences piletApi={piletApi} />
			<br />
			<br />
			<AsyncPasswordRequirements piletApi={piletApi} />
			<br />
			<br />
			<AsyncSocialSignIn piletApi={piletApi} />
			<br />
			<br />
			<AsyncAccountMFASettings piletApi={piletApi} />
			<br />
			<br />
			<AsyncSingleSignOn piletApi={piletApi} />
			<br />
			<br />
			<AsyncUserProfileActions
				piletApi={piletApi}
				firstName={'Identity'}
				lastName={'Team'}
				managedUserRoles={['Employee']}
				userRID={'sharefile:account-a123/user-e123'}
			/>
			<br />
			<br />
			<AsyncSupportSecurityQuestion piletApi={piletApi} />
		</>
	));
}
